import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, createBlock as _createBlock, withDirectives as _withDirectives, createVNode as _createVNode } from "vue"

import { onBeforeMount, onBeforeUpdate, Ref, ref } from 'vue'
import { storeToRefs } from 'pinia'
import { useStoreProfiles } from '../store/useStoreProfiles'
import BaseTypeAhead from './BaseTypeAhead.vue'
import { useI18n } from 'vue-i18n'

//translations

export default /*#__PURE__*/_defineComponent({
  __name: 'TypeAheadStores',
  props: {
    label: {},
    modelValue: {},
    rules: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const { t } = useI18n({ useScope: 'global' })
const formOption = (key: string) => t(`form.options.${key}`)
const errorMessage = (key: string) => t(`form.messages.${key}`)

//component setup
const props = __props
const emit = __emit

const locationOptions = ref([
  { name: 'home', type: 'home' },
  { name: 'warehouse', type: 'warehouse' },
  { name: 'other', type: 'other' },
])
const { getStores } = storeToRefs(useStoreProfiles())
const storeList = ref(
  getStores.value.data.map((store) => {
    return {
      type: 'store',
      store_id: store.store_id,
      name: store.store_name,
      number: store.store_number,
      address: {
        street: store.street,
        city: store.city,
        state: store.state,
        zip: store.zip,
      },
    }
  })
)
const allLocationOptions = ref([...locationOptions.value, ...storeList.value]) as Ref<
  {
    name: string
    type: 'home' | 'warehouse' | 'store' | 'other'
    number?: number
    address?: { street: string; city: string; state: string; zip: string }
  }[]
>

const update = (e: any) => {
  currentValue.value = e
  emit('update:modelValue', e)
}
const options = ref([...allLocationOptions.value])

const currentValue = ref()
onBeforeMount(() => {
  currentValue.value = props.modelValue
})
onBeforeUpdate(() => {
  currentValue.value = props.modelValue
})
const BaseTypeAheadRef = ref()
__expose({
  validate: () =>
    BaseTypeAheadRef.value ? BaseTypeAheadRef.value.validate() : console.log('no ref exists yet'),
})

return (_ctx: any,_cache: any) => {
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createBlock(BaseTypeAhead, {
    ref_key: "BaseTypeAheadRef",
    ref: BaseTypeAheadRef,
    label: _ctx.label,
    selected: currentValue.value,
    "onUpdate:selected": [
      _cache[0] || (_cache[0] = ($event: any) => ((currentValue).value = $event)),
      update
    ],
    "dropdown-options": options.value,
    "search-keys": ['name', 'number'],
    rules: _ctx.rules
  }, {
    "selected-item": _withCtx(({ opt }) => [
      (opt.type !== 'store')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createTextVNode(_toDisplayString(formOption(opt.name)), 1)
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createTextVNode(_toDisplayString(`${opt.name} #${opt.number}`), 1)
          ], 64))
    ]),
    option: _withCtx((optionProps) => [
      _withDirectives((_openBlock(), _createBlock(_component_q_item, {
        clickable: "",
        onClick: ($event: any) => {;(currentValue.value = optionProps.opt), _ctx.$emit('update:modelValue', currentValue.value)}
      }, {
        default: _withCtx(() => [
          (optionProps.opt.type !== 'store')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(_toDisplayString(formOption(optionProps.opt.name)), 1)
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode(_toDisplayString(`${optionProps.opt.name} #${optionProps.opt.number}`), 1)
              ], 64))
        ]),
        _: 2
      }, 1032, ["onClick"])), [
        [_directive_close_popup]
      ])
    ]),
    "no-option": _withCtx(() => [
      _createVNode(_component_q_item, null, {
        default: _withCtx(() => [
          _createVNode(_component_q_item_section, { class: "text-grey" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(errorMessage('noResults')), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["label", "selected", "dropdown-options", "rules"]))
}
}

})